<template>
  <div class="vz-progress-bar">
    <div
        class="vz-progress-bar-track"
        :style="{ height: `${height ? height : 4}px` }"
    >
      <div
          class="vz-progress-bar-thumb"
          :style="{ width: percent + '%', backgroundColor: indicatorColor }"
      ></div>
    </div>
    <div class="vz-progress-bar-label" v-if="showValue">{{ percent }}</div>
  </div>
</template>

<script>
/**
 * Shows a progress bar with optional percente label.
 * @module VzProgressBar
 * @param {Number} value Number from 0 to 1.
 * @param {Boolean} showValue Whether to show percent label.
 * @param {String} indicatorColor To change the background color.
 * @author Lanza
 */
export default {
  name: "VzProgressBar",

  props: {
    height: {
      type: Number,
      default: 4,
    },
    value: {
      type: Number,
      default: 0,
    },
    showValue: {
      type: Boolean,
      default: false,
    },
    indicatorColor: {
      type: String,
      default: '#46EB7E',
    }
  },

  computed: {
    percent: function () {
      const val = Math.max(0, Math.min(+this.value, 1));
      const roundedValue = Math.round(val * 100);
      return isNaN(roundedValue) ? 0 : roundedValue;
    },
  },
};
</script>

<style>
.vz-progress-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vz-progress-bar-track {
  width: 100%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 1px;
}

.vz-progress-bar-thumb {
  height: 100%;
  border-radius: 1px;
}

.vz-progress-bar-label {
  font-size: 0.8em;
  text-align: right;
  margin: 0 0 0 8px;
}

.vz-progress-bar-label:after {
  content: "%";
}
</style>
